<template>
  <SectionSplit
    class="Convocation reverse"
    src="../../assets/landing/header.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.Convocation {
  .body {
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Reconvened Meeting of Sun Investment Group Bondholders",
    "paragraphs": [
      "On 30 May 2025, Sun Investment Group, UAB held a reconvened meeting of bondholders (ISIN code LT0000409963). The meeting resolved to extend the deadline for publishing the company’s audited consolidated and stand-alone annual financial statements for 2024 to 30 June 2025.",
      "For more details, see the official announcement <a href=\"https://view.news.eu.nasdaq.com/view?id=1366644&lang=en\" target=\"_blank\">here</a>."
    ]
  },
  "lt": {
    "title": "Sun Investment Group obligacijų savininkų pakartotinis susirinkimas",
    "paragraphs": [
      "2025 m. gegužės 30 d. įvyko Sun Investment Group, UAB obligacijų (ISIN kodas LT0000409963) savininkų pakartotinis susirinkimas. Jame nutarta pratęsti metinių audituotų konsoliduotų ir atskirų finansinių ataskaitų už 2024 m. pateikimo terminą iki 2025 m. birželio 30 d.",
      "Plačiau apie susirinkimą galima skaityti čia: <a href=\"https://view.news.eu.nasdaq.com/view?id=1366644&lang=lt\" target=\"_blank\">nuoroda į oficialų pranešimą</a>."
    ]
  }
}
</i18n>
